// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__1UW2U","activeMenuItem":"MenuItem_activeMenuItem__117D2"};